// extracted by mini-css-extract-plugin
export var Active = "Archive-module--Active--29574";
export var AfterActive = "Archive-module--AfterActive--0bd7f";
export var BPTLButtonRow = "Archive-module--BPTLButtonRow--a6853";
export var BPTLDescription = "Archive-module--BPTLDescription--e260a";
export var BeforeActive = "Archive-module--BeforeActive--05ae5";
export var Block = "Archive-module--Block--efb7c";
export var Block_Img = "Archive-module--Block_Img--9b289";
export var Block_Text = "Archive-module--Block_Text--26733";
export var Blocks = "Archive-module--Blocks--fd384";
export var Button = "Archive-module--Button--8416c";
export var Content = "Archive-module--Content--86225";
export var CustomHeader = "Archive-module--CustomHeader--6cdb1";
export var DoubleMargin = "Archive-module--DoubleMargin--9a661";
export var Hidden = "Archive-module--Hidden--b4c56";
export var Info = "Archive-module--Info--eeac6";
export var InputWrapper = "Archive-module--InputWrapper--74ebb";
export var Leader = "Archive-module--Leader--a3cfd";
export var Logo = "Archive-module--Logo--7be9b";
export var MadeImage = "Archive-module--MadeImage--cd13e";
export var MadeSponsor = "Archive-module--MadeSponsor--b0c8b";
export var Map = "Archive-module--Map--e7c90";
export var MapImage = "Archive-module--MapImage--a93ed";
export var Padding = "Archive-module--Padding--8dce1";
export var PageCount = "Archive-module--PageCount--bbd39";
export var Pagination = "Archive-module--Pagination--dc93b";
export var ReadMoreButton = "Archive-module--ReadMoreButton--ee64e";
export var SingleMargin = "Archive-module--SingleMargin--3b13b";
export var SponsoredBy = "Archive-module--SponsoredBy--2154d";
export var SponsorsLogo = "Archive-module--SponsorsLogo--9ad5b";
export var SuggestWrapper = "Archive-module--SuggestWrapper--ff8b9";
export var SuggestYourOwn = "Archive-module--SuggestYourOwn--e7a6c";
export var Wrapper = "Archive-module--Wrapper--b6047";